import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=b1084104"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports